/**
 * This reducer is used for fetching shipping methods
 */
import {
    GET_SHIPPING_METHODS,
    GET_SHIPPING_METHODS_SUCCESS,
    GET_SHIPPING_METHODS_FAILURE,
    CLEAR_SHIPPING_ADDRESS,
} from '../actions';
import { TISSUE_AND_NON_TISSUE_SALES_ORG } from 'src/constants/productConstants';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const initialState = {
    shippingMethods: {
        [TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue]: [],
        [TISSUE_AND_NON_TISSUE_SALES_ORG.tissue]: [],
    },
    loading: false,
    statusCode: 0,
    statusMessage: '',
};

//    shippingDetails: {
//                     ...state.shippingDetails,
//                     [action.payload.salesOrg]: {
//                         ...state.shippingDetails[action.payload.salesOrg],
//                         ...action.payload,
//                     },
//                 },

const shippingMethodsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_SHIPPING_METHODS:
            return {
                ...state,
                loading: true,
            };
        case GET_SHIPPING_METHODS_SUCCESS:
            return {
                ...state,
                // shippingMethods: [...state.shippingMethods, ...action.payload],
                shippingMethods: {
                    ...state.shippingMethods,
                    [action.payload.salesOrg ===
                    TISSUE_AND_NON_TISSUE_SALES_ORG.tissue
                        ? TISSUE_AND_NON_TISSUE_SALES_ORG.tissue
                        : TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue]: [
                        ...(action.payload.data || []),
                    ],
                },
                statusCode: action?.statusCode,
                showShippingMethods: action.payload.showShippingMethods,
                statusMessage: action.statusMessage,
                loading: false,
            };
        case GET_SHIPPING_METHODS_FAILURE:
            return {
                ...state,
                shippingMethods: [],
                statusCode: action?.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
            };
        case CLEAR_SHIPPING_ADDRESS:
            return {
                ...state,
                shippingMethods: {
                    ...state.shippingMethods,
                    [action.payload]: [],
                },
                loading: false,
            };
        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'surgeryShippingMethodsKey',
        storage: storage,
    },
    shippingMethodsReducer
);
